export default __webpack_public_path__ + "static/media/UI_ButtonAdd.ee202981.png";